export default __webpack_public_path__ + "static/media/Recycle.2fdf4ccc.svg";